/* eslint-disable */
import { useState, useEffect } from "react";
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";
import { useTranslation } from "react-i18next";

const ActionLogDetailsOffcanvas = ({ logId, onClose }) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");

  const [log, setLog] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!logId) return;
    const fetchDetails = async () => {
      try {
        setIsLoading(true);
        setLog(null);
        const requestUrl =
          url.API_BASEURL + url.API_GET_ACTION_LOG_DETAILS + `/${logId}?token=${token}`;
        const response = await getData(requestUrl);
        if (response.status) setLog(response.data);
      } catch (err) {
        console.error(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchDetails();
  }, [logId]);

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="actionLogDetailsOffcanvas"
      aria-labelledby="actionLogDetailsOffcanvasLabel"
      style={{ width: "520px" }}
    >
      {/* ── Header ── */}
      <div className="offcanvas-header border-bottom">
        <h5 className="offcanvas-title d-flex align-items-center gap-2" id="actionLogDetailsOffcanvasLabel">
          <span className="material-symbols-outlined">history</span>
          {t("Log Details")}
        </h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={onClose}
        />
      </div>

      {/* ── Body ── */}
      <div className="offcanvas-body p-0">

        {isLoading && (
          <div className="p-4">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="mb-3">
                <div className="placeholder-glow mb-1">
                  <span className="placeholder col-3 rounded" style={{ height: "12px" }} />
                </div>
                <div className="placeholder-glow">
                  <span className={`placeholder col-${7 + (i % 3)} rounded`} style={{ height: "18px" }} />
                </div>
              </div>
            ))}
          </div>
        )}

        {!isLoading && log && (
          <>
            {/* ── Who / When ── */}
            <div className="px-4 py-3 border-bottom bg-light">
              <div className="row g-2">
                <div className="col-6">
                  <p className="text-muted small mb-0">{t("User")}</p>
                  <p className="fw-semibold mb-0">{log.fullname || "—"}</p>
                  <p className="text-muted small mb-0">{log.email || ""}</p>
                </div>
                <div className="col-3">
                  <p className="text-muted small mb-0">{t("Date")}</p>
                  <p className="fw-semibold mb-0">{log.actiondate || "—"}</p>
                </div>
                <div className="col-3">
                  <p className="text-muted small mb-0">{t("IP")}</p>
                  <p className="fw-semibold mb-0">{log.ipaddress || "—"}</p>
                </div>
              </div>
            </div>

            {/* ── What ── */}
            <div className="px-4 py-3 border-bottom">
              <div className="row g-2">
                <div className="col-4">
                  <p className="text-muted small mb-1">{t("Action")}</p>
                  <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 fw-normal">
                    {log.action || "—"}
                  </span>
                </div>
                
                <div className="col-4">
                  <p className="text-muted small mb-1">{t("Module")}</p>
                  <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 fw-normal">
                    {log.module || "—"}
                  </span>
                </div>
                
                <div className="col-4">
                  <p className="text-muted small mb-1">{t("Component")}</p>
                  <span className="badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25 fw-normal">
                    {log.entitycustomerid || "—"}
                  </span>
                </div>
              </div>
              {log.url && (
                <div className="mt-2">
                  <p className="text-muted small mb-1">{t("URL")}</p>
                  <code className="small text-break">{log.url}</code>
                </div>
              )}
            </div>

            {/* ── Entity ref ── */}
            {log.reserveevent && (
              <div className="px-4 py-3 border-bottom">
                <p className="text-muted small fw-semibold text-uppercase mb-2">{t("Reserve Event")}</p>
                <div className="row g-2 small">
                  <div className="col-6"><span className="text-muted">{t("Reserve ID")}: </span><strong>{log.reserveevent.reserveid}</strong></div>
                  <div className="col-6"><span className="text-muted">{t("Customer ID")}: </span><strong>{log.reserveevent.customerid}</strong></div>
                  <div className="col-6"><span className="text-muted">{t("Date")}: </span>{log.reserveevent.startdate}</div>
                  <div className="col-6"><span className="text-muted">{t("Time")}: </span>{log.reserveevent.starttime} – {log.reserveevent.endtime}</div>
                  <div className="col-6"><span className="text-muted">{t("Status")}: </span>{log.reserveevent.reservestatus}</div>
                </div>
              </div>
            )}

            {log.account && (
              <div className="px-4 py-3 border-bottom">
                <p className="text-muted small fw-semibold text-uppercase mb-2">{t("Account")}</p>
                <div className="row g-2 small">
                  <div className="col-6"><span className="text-muted">{t("Name")}: </span><strong>{log.account.name} {log.account.surname}</strong></div>
                  <div className="col-6"><span className="text-muted">{t("Email")}: </span>{log.account.email}</div>
                </div>
              </div>
            )}

            {log.company && (
              <div className="px-4 py-3 border-bottom">
                <p className="text-muted small fw-semibold text-uppercase mb-2">{t("Company")}</p>
                <div className="row g-2 small">
                  <div className="col-6"><span className="text-muted">{t("Name")}: </span><strong>{log.company.name}</strong></div>
                  <div className="col-6"><span className="text-muted">{t("Email")}: </span>{log.company.email}</div>
                </div>
              </div>
            )}

            {log.activity && (
              <div className="px-4 py-3 border-bottom">
                <p className="text-muted small fw-semibold text-uppercase mb-2">{t("Activity")}</p>
                <div className="row g-2 small">
                  <div className="col-6"><span className="text-muted">{t("Name")}: </span><strong>{log.activity.name}</strong></div>
                  <div className="col-6"><span className="text-muted">{t("Code")}: </span>{log.activity.code}</div>
                </div>
              </div>
            )}

            {/* ── Params (req.body) ── */}
            {log.params && Object.keys(log.params).length > 0 && (
              <div className="px-4 py-3">
                <p className="text-muted small fw-semibold text-uppercase mb-2">
                  <span className="material-symbols-outlined align-middle me-1" style={{ fontSize: "14px" }}>data_object</span>
                  {t("Request Params")}
                </p>
                <pre
                  className="small bg-light border rounded p-3 mb-0"
                  style={{ whiteSpace: "pre-wrap", wordBreak: "break-all", maxHeight: "400px", overflowY: "auto", fontSize: "11px" }}
                >
                  {JSON.stringify(log.params, null, 2)}
                </pre>
              </div>
            )}
          </>
        )}

        {!isLoading && !log && (
          <div className="p-4 text-center text-muted">
            <span className="material-symbols-outlined d-block mb-2" style={{ fontSize: "40px" }}>
              error_outline
            </span>
            {t("Could not load log details")}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActionLogDetailsOffcanvas;
